import * as feedbackService from './feedbacksvc.service.js';

export default angular.module('gcs.feedbackService', ['rhino.components.session'])
  .factory(feedbackService.moduleName, feedbackService.default)
  .name;

